// extracted by mini-css-extract-plugin
export default {"container":"SquareAdmis_container__fyBgB","header":"SquareAdmis_header__Ffiw4","closeBtn":"SquareAdmis_closeBtn__LIUOS","formContainer":"SquareAdmis_formContainer__tDjZo"};